export enum RolesWizardStep {
  name = "name",
  privileges = "privileges",
  assign = "assign",
  editDatabasePrivileges = "editDatabasePrivileges",
  editPrivileges = "editPrivileges",
}

export enum OrganizationRolesWizardStep {
  name = "name",
  privileges = "privileges",
  assign = "assign",
}

export type NameStepType = {
  name: string;
};

export type AssignStepType = {
  grantee: string[] | null;
};

export type PrivilegesStepType = {
  privileges: PrivilegesState | null;
  diff?: any;
};

export type RolesDataType = {
  [RolesWizardStep.name]: NameStepType;
  [RolesWizardStep.privileges]: PrivilegesStepType;
  [RolesWizardStep.editPrivileges]: PrivilegesStepType;
  [RolesWizardStep.editDatabasePrivileges]: PrivilegesStepType;
  [RolesWizardStep.assign]: AssignStepType;
};

export type PermissionError = {
  object: string;
  resource: string;
  action: string;
  catalogName?: string;
  ignored?: boolean;
  errorSource: {
    type: string;
    name: string;
    actions: string[];
    catalogName: string;
  };
};

export type PrivilegesState = {
  engine: {
    toAssign: string[];
    toDeny: string[];
    objects: string[];
    expanded?: boolean;
  }[];
  account: {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: string[];
  }[];
  database: {
    toAssign: string[];
    toDeny: string[];
    objects: string[];
    expanded?: boolean;
  }[];
  table: {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: { catalogName: string; name: string }[];
  }[];
  view: {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: { catalogName: string; name: string }[];
  }[];
  schema: {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: { catalogName: string; name: string }[];
  }[];

  login: {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: string[];
  }[];
  organization: {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: string[];
  }[];
  "network policy": {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: string[];
  }[];
  "service account": {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: string[];
  }[];
  role: {
    toAssign: string[];
    toDeny: string[];
    expanded?: boolean;
    objects: string[];
  }[];
};

export type PrivilegesErrors = {
  emptySectionErrors?: Record<string, string[]>;
  permissionErrors: {
    table: PermissionError[];
    view: PermissionError[];
    schema: PermissionError[];
  };
};

export type DatabasePrivileges = {
  databasePrivileges: Record<
    string,
    PrivilegesState & { initialPrivileges: PrivilegesState }
  >;
};

export type PrivilegesStateWithErrors = PrivilegesState &
  PrivilegesErrors &
  DatabasePrivileges;

export const schemaPrivileges = [
  "USAGE",
  "MODIFY",
  "CREATE",
  "DELETE ANY",
  "INSERT ANY",
  "UPDATE ANY",
  "TRUNCATE ANY",
  "VACUUM ANY",
  "MODIFY ANY",
  "SELECT ANY",
];

export const viewPrivileges = ["SELECT", "MODIFY"];

export const tablePrivileges = [
  "DELETE",
  "INSERT",
  "UPDATE",
  "TRUNCATE",
  "VACUUM",
  "MODIFY",
  "SELECT",
];

export enum OrganizationPrivilegesObjectType {
  organization = "organization",
  account = "account",
  login = "login",
  service_account = "service account",
  network_policy = "network policy",
  role = "role",
}

export const organizationPrivilegesTypes = [
  OrganizationPrivilegesObjectType.organization,
  OrganizationPrivilegesObjectType.account,
  OrganizationPrivilegesObjectType.login,
  OrganizationPrivilegesObjectType.service_account,
  OrganizationPrivilegesObjectType.network_policy,
  OrganizationPrivilegesObjectType.role,
];
